export default __webpack_public_path__ + "static/BannerDraftJsWithImageListWithCharTitle_FourCol-a452a4377151999a2e920f2459ffbbc3.jpg";